import React from 'react';
import { providerName } from '../../../../utils';
import moment from 'moment';
import RadioGroup from '../../../BuildingBlocks/Form/RadioGroup';
import Header from '../../../BuildingBlocks/Headers/BoldHeader';

export default function LoanQuestions({ setValue, useWatch, control }) {
  const threeMonthsFromNow = moment().add(90, 'days').format('MMM DD, YYYY');
  const questions = [
    {
      id: 'yes',
      text: (
        <span>
          I confirm that I will terminate this loan by{' '}
          <b>
            <u>{threeMonthsFromNow}</u>
          </b>{' '}
          to comply with the agreement.
        </span>
      ),
    },
    {
      id: 'no',
      text: (
        <span>
          I’m unable to terminate this loan by{' '}
          <b>
            <u>{threeMonthsFromNow}</u>
          </b>{' '}
          and would like to speak with an {providerName} team member about my
          options.
        </span>
      ),
    },
  ];

  return (
    <>
      <Header>
        The {providerName} team identified an additional form of financing, such
        as a loan, in your records.
      </Header>
      <RadioGroup
        groupId="loans"
        options={Object.values(questions)}
        setValue={setValue}
        useWatch={useWatch}
        control={control}
      />
    </>
  );
}
